import request from "@/service";

// 查询调训分页
export function getTrainList (data) {
  return request({
    url: `/data/student/train/page`,
    method: "post",
    data
  });
}

export function TrainDetailList (data) {
  return request({
    url: `/data/student/train/detailPage`,
    method: "post",
    data
  });
}



/* 导出调训息 */
export function exportTrainList (params) {
  return request({
    url: `/data/student/train/exportExcel`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}
// 新增/编辑选调学员
export function saveTrainEnroll (data) {
  return request({
    url: `/study/class/enroll/saveTrainEnroll`,
    method: "post",
    data
  });
}
// 校验选调学员
export function validTrainEnroll (data) {
  return request({
    url: `/study/class/enroll/validTrainEnroll`,
    method: "post",
    data
  });
}


//导出结果
export function getStudentTrainExport() {
  return request({
    url: '/study/class/fileLibrary/getStudentTrainExport',
    method: 'get'
  })
}